module.exports = __webpack_public_path__ + "static/img/avatar-s-5.73b9c8f8.png";